__webpack_require__.p = "https://www.fxa.delfin.name/settings/prod/";